import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDescription } from 'helpers/content';
import { Link } from 'react-router-dom';
import { getGuardianStudentPost } from 'actions/posts';
import Message from 'containers/SinglePages/Partials/Message';
var ImmersiveReader = require('@microsoft/immersive-reader-sdk');
import { getReaderParameters } from 'actions/user';
import { setPageTitle } from 'actions/header';
import { getActiveSchool } from 'helpers/guardian';
import { Spinner } from 'UI';
import { Immersive_Reader } from 'UI/Icons';
import { CardSubtitle } from 'components/Presentation/Cards/Card';
import Date from 'components/Presentation/Dates/Date';
import PostContent from 'components/Presentation/PostContent';
import Block, { BlockWrapper } from 'components/Block/Block';
import { Icon, Block as ContentBlock, Button, getActiveLanguage, translate } from '@haldor/ui';
var SinglePost = /*#__PURE__*/function (_Component) {
  function SinglePost(props) {
    var _this;
    _classCallCheck(this, SinglePost);
    _this = _callSuper(this, SinglePost, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var activeStudent = _this.props.activeStudent;
      _this.setState({
        loading: true
      });
      _this.props.getGuardianStudentPost(activeStudent.id, _this.props.match.params.newsId).then(function () {
        _this.props.setPageTitle(_this.props.post.title);
        _this.setState({
          loading: false
        });
      })["catch"](function (error) {
        if (error.status == 204) {
          _this.setState({
            showNotFound: true
          });
        }
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "onConversationClose", function () {
      _this.setState({
        studentConversation: null
      });
    });
    _defineProperty(_this, "openConversation", function () {
      _this.setState({
        studentConversation: _this.props.activeStudent
      });
    });
    _defineProperty(_this, "runImmersiveReader", function () {
      var post = _this.props.post;
      var data = {
        title: post.title,
        chunks: [{
          content: '<h1>' + post.title + '</h1>',
          mimeType: 'text/html'
        }, {
          content: getDescription(post.body),
          mimeType: 'text/html'
        }]
      };
      _this.props.getReaderParameters().then(function () {
        var reader = _this.props.reader;
        ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
          uiLang: getActiveLanguage()
        })["catch"](function (error) {
          console.error('error', error);
          //trackImmersiveReaderError(error, currentUser.id);
        });
      });
    });
    _defineProperty(_this, "renderArticle", function () {
      var _this$props = _this.props,
        post = _this$props.post,
        translate = _this$props.translate;
      var conversation = null;
      if (_this.props.conversations != null && _this.props.user != null) {
        conversation = _this.props.conversations.find(function (conv) {
          return conv.memberships.find(function (member) {
            return member.membershipID == _this.props.user.id;
          });
        });
      }
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task single-preschool_document"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      if (post != null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(CardSubtitle, null, /*#__PURE__*/React.createElement(Date, null, post.published)))), /*#__PURE__*/React.createElement("div", {
          className: "single-task-description"
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, translate('Description')), /*#__PURE__*/React.createElement(Link, {
          to: "#",
          onClick: _this.runImmersiveReader
        }, /*#__PURE__*/React.createElement("div", {
          className: "reader trigger"
        }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate('Immersive Reader'))), /*#__PURE__*/React.createElement(PostContent, null, getDescription(post.body))), _this.props.activeStudent != null && _this.props.activeStudent.services.conversations && post.allowGuardianConversation ? /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.openConversation,
          style: {
            marginTop: "1rem",
            position: "relative"
          }
        }, translate('Conversation'), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null) : null), /*#__PURE__*/React.createElement("div", null, post.associatedFiles.length > 0 ? /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: "2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "preschool-gallery",
          style: {
            width: '100%'
          }
        }, post.associatedFiles.map(function (file, index) {
          var fileUrl = file.url;
          if (file.type.indexOf('image') > -1) {
            return /*#__PURE__*/React.createElement(Block, {
              key: "file-".concat(file.id, "-").concat(index)
            }, /*#__PURE__*/React.createElement("img", {
              src: fileUrl,
              style: {
                width: '100%',
                height: '100%',
                display: 'block',
                borderRadius: 'inherit'
              }
            }));
          }
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement("a", {
            href: fileUrl,
            className: "block-content",
            target: "_blank"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              width: '1.15rem',
              height: '1.15rem',
              position: 'relative',
              top: 3,
              marginRight: '0.55rem'
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "File"
          })), file.name));
        }))) : null), _this.props.activeStudent != null && _this.props.activeStudent.services.conversations && post.allowGuardianConversation ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(Message, {
          post: post,
          activeUser: _this.state.studentConversation,
          onClose: _this.onConversationClose
        })) : null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '1rem 0'
        },
        className: "text--center color--meta weight--bold"
      }, _this.props.translate("Something went wrong! We couldn't find what you were trying to reach!")))));
    });
    _this.state = {
      showNotFound: false,
      loading: false,
      studentConversation: null
    };
    return _this;
  }
  _inherits(SinglePost, _Component);
  return _createClass(SinglePost, [{
    key: "render",
    value: function render() {
      if (this.state.showNotFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem 0'
          },
          className: "text--center color--meta weight--bold"
        }, this.props.translate('You do not have permission to view the post')))));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.renderArticle());
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    post: state.posts.post,
    reader: state.User.reader,
    translate: translate(state.Languages.translations),
    conversations: state.Conversation.referenceConversations
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentPost: getGuardianStudentPost,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle
})(SinglePost);